<template>
  <v-app>
    <v-card class="bgs rounded-0 d-flex justify-center" flat width="100%" height="100%">
      <v-container>
        <h2 class="text-center mt-6 font24 mb-4">
          {{ $t("Taoify消费协议") }}
        </h2>
        <p class="content mt-4">
          {{ $t("提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify消费协议》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本消费协议约束。") }}
        </p>
        <p class="content">
          {{ $t("Taoify有权不定期更新、修改本消费协议里的内容，有权在 Taoify 网站上发布更新和修改本消费协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。") }}
        </p>
        <p class="content">
          {{ $t("本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》等为准。") }}
        </p>
        <p class="content">
          {{ $t("您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本消费协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。") }}
        </p>
        <p class="content">
          {{ $t("本协议中所有术语定义，均与《Taoify 服务条款》保持统一，不再重复释义。") }}
        </p>

        <h3 class="titlee">{{ $t("一、消费须知") }}</h3>
        <p class="content">
          {{ $t("1、Taoify 将向用户提供 Taoify 官网所展示的电商建站服务、相关的技术支持以及网络支持等服务。用户需按平台公示标准支付对应费用，具体包括但不限于订阅费用、保证金、交易佣金等。") }}
        </p>
        <p class="content">
          {{ $t("2、所有服务收费标准都在订购页面予以列明公示，您可自行选择具体服务类型、服务套餐，并按列明的价格支付费用。您可以登录店铺后台，依次点击「后台设置」>「账单」>「账单管理」进行查看付费明细。") }}
        </p>

        <h3 class="titlee">{{ $t("二、服务费用与付费方式") }}</h3>
        <h4 style="font-size:16px;font-weight:600;color:#333;margin-top:15px;">{{ $t("1、服务费用") }}</h4>
        <p class="content">
          {{ $t("您可以按照您的需求，根据方案计价选择相应的套餐类型，并根据所选择的套餐类型支付服务费用。") }}
        </p>
        <h4 style="font-size:16px;font-weight:600;color:#333;margin-top:15px;">{{ $t("2、付费方式") }}</h4>
        <p class="content">
          {{ $t("2.1 预付制") }}
        </p>
        <p class="content">
          {{ $t("2.1.1 店铺订阅费用采用预付模式，系统将在服务到期前5个自然日自动发起续费扣款。续费、扣款失败、退回等完整规则见《Taoify 服务条款》。") }}
        </p>
        <p class="content">
          {{ $t("2.1.2 保证金采用预付制，用户完成账户注册时，须一次性足额缴纳经营保证金1000元，保证金不得抵扣订阅费、税费。保证金支付、退回等完整规则见《Taoify 服务条款》。") }}
        </p>
        <p class="content">
          {{ $t("2.1.3 费用支付后，平台提供服务。若因付款异常导致支付中止，您可在商城「后台设置」>「账单」>「账单管理」中查看处理结果，并手工完成支付。") }}
        </p>
        <p class="content">
          {{ $t("2.2 付费") }}
        </p>
        <p class="content">
          {{ $t("2.2.1 佣金") }}
        </p>
        <p class="content">
          {{ $t("2.2.1.1 用户按平台公示标准向平台支付佣金；平台现行阶段暂未计收佣金，具体费率以平台届时公示为准。") }}
        </p>
        <p class="content">
          {{ $t("2.2.1.2 Taoify收取的佣金基于订单的付款状态计取，每月销售付款金额以平台后台生成的订单截图为准，若由于后续订单产生退款等，不退还该笔订单的佣金。") }}
        </p>
        <p class="content">
          {{ $t("2.2.1.3 平台于每月月底向用户出具当月付款销售业务的结算报告（包括销售付款金额及相应佣金金额）并交付给用户。用户在收到结算报告后2日内提出异议，若未提出异议视为认可结算报告。用户须于收到结算报告后5日内，单独向平台付清该月佣金。若用户在收到结算报告后2日内提出书面异议的，就无争议佣金须于收到结算报告5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期佣金暂按平台原结算报告金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。") }}
        </p>
        <p class="content">
          {{ $t("2.3 其他费用") }}
        </p>
        <p class="content">
          {{ $t("2.3.1 除订阅费用、保证金、佣金外，经用户申请，平台自行内部审核通过后，用户可与Taoify平台另行签约开通后付费模式，签约后用户可以先使用Taoify为您提供的服务，平台再清算您店铺内所产生的费用，并通过线下交易的形式收取。") }}
        </p>
        <p class="content">
          {{ $t("2.3.2 Taoify 后付费的具体流程：用户申请；平台自行内部审核通过；Taoify 在每月结束后通过 Taoify 客服通知您的账单；如您对账单有任何异议的，应于下月15日之前向 Taoify 客服书面提出，未在上述期限提出书面异议的，视为认可该账单及发票。用户须于收到账单后5日内，单独向平台付清。若用户在收到账单后2日内提出书面异议的，就无争议部分须于收到账单5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期费用暂按平台原账单金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。") }}
        </p>

        <h3 class="titlee">{{ $t("三、费用支付") }}</h3>
        <ul>
          <li>{{ $t("1、您必须向平台提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。") }}</li>
          <li>{{ $t("2、账单生成后，系统将通过您授权的支付方式自动扣款，该扣款流程持续至本服务终止。若您设置默认支付卡，系统将优先从默认卡完成扣费。除另行约定外，所有费用均以美元作为结算及支付币种。") }}</li>
          <li>{{ $t("3、费用将显示在账单上，并通过提供的电子邮件发送至商店所有者。如果您对账单存在疑问，可以与 Taoify 的相关业务部门进行联系。后续将通过电子邮件的形式与您取得联系，账单争议内容将发送至您所提供的店铺财务邮箱。") }}</li>
          <li>{{ $t("4、针对 Taoify 自身收取的平台服务费，可联系平台对应业务部门办理，发票将通过邮件发送至您预留的店铺财务邮箱；第三方收取的款项，您应直接对接第三方主体办理，Taoify 可予以必要配合。") }}</li>
          <li>{{ $t("5、平台提前30日发出服务费用变更通知后即可调整服务收费标准，平台可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。") }}</li>
          <li>{{ $t("6、平台不就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。") }}</li>
          <li>{{ $t("7、若平台无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。平台每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，平台有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。") }}</li>
          <li>{{ $t("8、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。") }}</li>
          <li>{{ $t("9、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本消费协议中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向平台提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。") }}</li>
          <li>{{ $t("10、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本消费协议约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。") }}</li>
          <li>{{ $t("11、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。") }}</li>
          <li>{{ $t("12、平台订阅费用、交易佣金应用费、模板费、罚金等均不支持退款；用户主动注销、中途终止服务、违规封禁账号，已缴纳全部费用不予返还；订单售后退款、退货的，对应订单已扣除佣金不予退还。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("四、罚金政策") }}</h3>
        <ul>
          <li>{{ $t("1、商家应确保及时、准确地处理订单、并将物流单号同步到后台。超时发货的订单采取了严格的处罚措施，具体处罚措施：付款30天内没有上传物流单号，每单额外收取0.5美元罚金。") }}</li>
          <li>{{ $t("2、对于定制类、预售等可能需要超过30天的类目，须向 Taoify 书面提出申请延长发货申请，审批通过后不予处罚。") }}</li>
          <li>{{ $t("3、Taoify 系统只提供基础建站功能，不提供、不负责买家与用户的资金处理与结算，资金相关的服务由第三方支付机构处理，相应风险由用户承担。") }}</li>
          <li>{{ $t("4、若用户店铺单个自然月超时发货订单满5笔，或同一自然年度内累计超时发货订单满20笔的，用户除按约定向平台支付对应罚金外，平台亦有权依据平台公示协议及规则，暂停店铺经营服务、单方终止双方合作，且用户已向平台缴纳的全部费用不予退还。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("五、服务到期或欠款") }}</h3>
        <p class="content">
          {{ $t("1、服务到期") }}
        </p>
        <p class="content">
          {{ $t("1.1 按时计费") }}
        </p>
        <p class="content">
          {{ $t("1.1.1 免费试用版：服务期限自平台为用户开通试用当日起算，到期未付费自动关闭站点。") }}
        </p>
        <p class="content">
          {{ $t("1.1.2 付费版：服务期自用户支付服务费用付费或套餐支付费用后激活之日起计算，到期时间以店铺后台公示为准。") }}
        </p>
        <p class="content">
          {{ $t("2、按量计费：若您使用的是先付费服务，即先购买服务次数/条数再使用的，在服务项目服务次数/条数在使用过程中消耗至零时，即视为服务到期。") }}
        </p>

        <h3 class="titlee">{{ $t("第六条 争议解决") }}</h3>
        <p class="content">
          {{ $t("1、平台有关条款（包括但不限于本消费协议等）可能会有除中文以外的其他版本。如果不同语言版本的消费协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本消费协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本消费协议，予以明确排除。") }}
        </p>
        <p class="content">
          {{ $t("2、因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。") }}
        </p>
        <p class="content">
          {{ $t("3、争议处理期间，除争议事项外，双方应继续履行本协议其他约定。") }}
        </p>
        <p class="content">
          {{ $t("4、本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。") }}
        </p>

        <h3 class="titlee">{{ $t("第七条 其他约定") }}</h3>
        <p class="content">
          {{ $t("1、运营主体：本平台由香港星橋國際貿易有限公司（https://aitaoify.com，以下简称\"Taoify\"或\"平台\"）运营。您可通过邮箱 liutaotao@taocarts.com 或微信号 zzsist666 与平台取得联系。") }}
        </p>
        <p class="content">
          {{ $t("2、未成年人使用：本平台服务面向具有完全民事行为能力的主体。未成年人应在监护人陪同、指导下阅读本协议并在监护人同意后方可注册、使用本平台服务；监护人应就未成年人使用平台的行为承担相应法律责任。") }}
        </p>
        <p class="content">
          {{ $t("3、知识产权：Taoify平台的商标、标识、页面设计、文案、软件、代码等知识产权均归平台或相关权利人所有，未经书面许可，任何人不得复制、修改、传播或用于商业用途。用户对其自行上传的内容依法享有权利，并保证该内容不侵犯第三方合法权益。") }}
        </p>
        <p class="content">
          {{ $t("4、通知送达：平台通过您预留的注册邮箱、店铺后台公告、站内消息或短信发出的通知，于发出之日即视为送达。您应保持联系方式有效，因联系方式变更未及时通知平台导致的后果由您自行承担。") }}
        </p>
        <p class="content">
          {{ $t("5、完整协议：本协议连同《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》构成您与平台之间关于使用本平台服务的完整约定，取代此前双方就同一事项达成的口头或书面约定。") }}
        </p>
        <p class="content">
          {{ $t("6、本协议更新日期：2026年1月1日；生效日期：2026年1月1日。") }}
        </p>

        <p class="content">
          © {{ year }} Taoify · {{ $t("香港星橋國際貿易有限公司") }} · {{ $t("版权所有") }}
        </p>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>
export default {
  data() {
    return { year: new Date().getFullYear() };
  }
};
</script>

<style lang="scss" scoped>
.titlee {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 25px;
  margin-top: 25px;
  margin-bottom: 10px;
}
.content {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
}
li {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
  margin-left: 20px;
  list-style: initial;
}
</style>
